__webpack_require__.p = "https://static-basket-02.wbbasket.ru/vol20/landing-about-portal-next-front/latest/_next/";